import { PDF_EXPORT_QUERY_PARAM_EXPORT_MODE } from 'common/constants/pdfExport';
import { Units } from 'common/types/format';
import { MILLIONS_UNIT, REGULAR_UNIT, THOUSANDS_UNIT } from 'components/FeaturedSpreadsheet/constants';

export const RELATED_ENTITY_OWNER_VALUE = 'related_entity';
export const FUND_OWNER_VALUE = 'fund';
export const NAME_SHEET_FUND_KEY = '_f';
export const NAME_SHEET_RELATED_ENTITY_KEY = '_re';

// Waterfall query params
export const WATERFALL_QUERY_PARAM_EXIT_EQUITY_VALUE = 'exit-equity-value';
export const WATERFALL_QUERY_PARAM_EXIT_ENTERPRISE_VALUE = 'exit-enterprise-value';
export const WATERFALL_QUERY_PARAM_EXIT_DATE = 'exit-date';
export const WATERFALL_QUERY_PARAM_CAP_TABLE_VERSION = 'cap-table-version';
export const WATERFALL_QUERY_PARAM_PLUS_CASH = 'plus-cash';
export const WATERFALL_QUERY_PARAM_LESS_DEBT = 'less-debt';
export const WATERFALL_QUERY_PARAM_FOREIGN_CURRENCY = 'foreign-currency';
export const WATERFALL_QUERY_PARAM_CURRENCY_FORMAT = 'currency-format';
export const WATERFALL_QUERY_PARAM_FOREIGN_EXCHANGE_RATE = 'foreign-exchange-rate';
export const WATERFALL_QUERY_PARAM_FOREIGN_EXCHANGE_RATE_OVERRIDDEN = 'foreign-exchange-rate-overridden';
export const WATERFALL_QUERY_PARAM_FOREIGN_EXCHANGE_RATE_INPUT_CURRENCY = 'foreign-exchange-rate-input-currency';
export const WATERFALL_QUERY_PARAM_VIEW = 'view';
export const WATERFALL_QUERY_PARAM_DATE = 'date';
export const WATERFALL_QUERY_PARAM_EXPORT_MODE = PDF_EXPORT_QUERY_PARAM_EXPORT_MODE;
export const WATERFALL_QUERY_PARAM_CURRENT_PAGE = 'currentPage';
export const WATERFALL_QUERY_PARAM_TOTAL_PAGES = 'totalPages';

export const WATERFALL_CURRENCY_FORMAT = {
  REGULAR: 'regular',
  THOUSANDS: 'thousands',
  MILLIONS: 'millions',
} as const;

export type WaterfallCurrencyFormat = (typeof WATERFALL_CURRENCY_FORMAT)[keyof typeof WATERFALL_CURRENCY_FORMAT];
export type WaterfallExchangeRateInputCurrency = 'base' | 'foreign';

export const WATERFALL_CURRENCY_FORMAT_TO_UNITS: Record<WaterfallCurrencyFormat, Units> = {
  [WATERFALL_CURRENCY_FORMAT.REGULAR]: REGULAR_UNIT,
  [WATERFALL_CURRENCY_FORMAT.THOUSANDS]: THOUSANDS_UNIT,
  [WATERFALL_CURRENCY_FORMAT.MILLIONS]: MILLIONS_UNIT,
};

export const WATERFALL_UNITS_TO_CURRENCY_FORMAT: Record<Units, WaterfallCurrencyFormat> = {
  [REGULAR_UNIT]: WATERFALL_CURRENCY_FORMAT.REGULAR,
  [THOUSANDS_UNIT]: WATERFALL_CURRENCY_FORMAT.THOUSANDS,
  [MILLIONS_UNIT]: WATERFALL_CURRENCY_FORMAT.MILLIONS,
};

// Allowed parameters for waterfall page
export const WATERFALL_ALLOWED_PARAMS = [
  WATERFALL_QUERY_PARAM_CAP_TABLE_VERSION,
  WATERFALL_QUERY_PARAM_EXIT_EQUITY_VALUE,
  WATERFALL_QUERY_PARAM_EXIT_ENTERPRISE_VALUE,
  WATERFALL_QUERY_PARAM_PLUS_CASH,
  WATERFALL_QUERY_PARAM_LESS_DEBT,
  WATERFALL_QUERY_PARAM_FOREIGN_CURRENCY,
  WATERFALL_QUERY_PARAM_CURRENCY_FORMAT,
  WATERFALL_QUERY_PARAM_FOREIGN_EXCHANGE_RATE,
  WATERFALL_QUERY_PARAM_FOREIGN_EXCHANGE_RATE_OVERRIDDEN,
  WATERFALL_QUERY_PARAM_FOREIGN_EXCHANGE_RATE_INPUT_CURRENCY,
  WATERFALL_QUERY_PARAM_VIEW,
  WATERFALL_QUERY_PARAM_EXIT_DATE,
  WATERFALL_QUERY_PARAM_DATE,
  WATERFALL_QUERY_PARAM_EXPORT_MODE,
  WATERFALL_QUERY_PARAM_CURRENT_PAGE,
  WATERFALL_QUERY_PARAM_TOTAL_PAGES,
];
